<template>
  <div class="tregisters">
    <md-progress-bar md-mode="indeterminate" v-if="loading" />

    <TRegister
      v-if="newUser != null"
      :details="newTregisterDetail"
      @tregister-created="getTregisterDetails"
      :newUser="newUser"
      @close-modal="newUser = null"
    />

    <md-dialog :md-active.sync="isMassive">
      <md-progress-bar
        class="md-accent"
        md-mode="query"
        v-if="this.loading_files"
      ></md-progress-bar>
      <md-dialog-title>Carga masiva de T-Registros</md-dialog-title>
      <md-field>
        <a
          ref="excel-tr"
          download
          href="/files/Plantilla T-Registros.xlsx"
          v-show="false"
        ></a>
        <a
          ref="excel-dh"
          download
          href="/files/Plantilla Derecho habientes.xlsx"
          v-show="false"
        ></a>
        <!-- <a ref="excel-bc" download href="/files/Plantilla Historico.xlsx" v-show="false"></a> -->
        <md-button class="md-accent md-raised" @click="downloadExcel('excel-tr')"
          >Excel T-Registro</md-button
        >
        <md-button class="md-accent md-raised" @click="downloadExcel('excel-dh')"
          >Excel Der. Hab.</md-button
        >
        <!-- <md-button class="md-accent md-raised" @click="downloadExcel('excel-bc')">Excel Historico</md-button> -->
      </md-field>
      <md-field>
        <label>Carga de Archivo</label>
        <md-file
          v-model="placeholder_tregisters"
          placeholder="Cargue el archivo excel de los T-registros"
          @md-change="getFile($event, 'tregister')"
        />
      </md-field>
      <md-field>
        <label>Carga de Archivo</label>
        <md-file
          v-model="placeholder_rightHolders"
          placeholder="Cargue el archivo excel de los Derecho Habientes"
          @md-change="getFile($event, 'rightholder')"
        />
      </md-field>
      <!-- <md-field>
        <label>Carga de Archivo</label>
        <md-file
          v-model="placeholder_Historic"
          placeholder="Cargue el archivo excel del histórico de Bonos y Comisiones"
          @md-change="getFile($event, 'historic')"
        />
      </md-field> -->
      <md-dialog-actions>
        <md-button class="md-primary" @click="isMassive = false">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click="cargaMasiva">Cargar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="tregisters__tabs">
      <div
        class="tregisters__tab"
        @click="toView('trDrafts')"
        :class="{ 'tab-selected': $route.name === 'trDrafts' }"
      >
        Borradores
      </div>
      <div
        class="tregisters__tab"
        @click="toView('trForEmployee')"
        :class="{ 'tab-selected': $route.name === 'trForEmployee' }"
      >
        Para Habilitar Tareo
      </div>
      <div
        class="tregisters__tab"
        @click="toView('trHasEmployee')"
        :class="{ 'tab-selected': $route.name === 'trHasEmployee' }"
      >
        Con Tareo
      </div>
      <div
        class="tregisters__tab"
        @click="toView('trDown')"
        :class="{ 'tab-selected': $route.name === 'trDown' }"
      >
        De Baja
      </div>
      <div
        v-show="$route.name === 'trDrafts' && show"
        class="tregisters__add-massive"
        @click="isMassive = true"
      >
        <img :src="require('@/assets/img/xlsx.svg')" v-if="toogleAddUser" alt />
        <button v-else>Carga masiva</button>
      </div>
      <div
        v-show="$route.name === 'trDrafts' && show"
        class="tregisters__add-user"
        @click="newUser = true"
      >
        <img :src="require('@/assets/img/add-user.svg')" v-if="toogleAddUser" alt />
        <button v-else>Agregar empleado</button>
      </div>
    </div>

    <div class="tregisters__components">
      <transition name="fade" mode="out-in">
        <!-- <keep-alive> -->
        <router-view
          name="tregistros-view"
          @loading-status="loading = $event"
        ></router-view>
        <!-- </keep-alive> -->
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EventBus from "@/eventBus.js";
import Pendings from "@/components/TRegisters/Pendings";
import Registers from "@/components/TRegisters/Registers";
import Down from "@/components/TRegisters/Down";
import Draft from "@/components/TRegisters/Draft";
import ForEmployee from "@/components/TRegisters/ForEmployee";
import HasEmployee from "@/components/TRegisters/HasEmployee";

export default {
  name: "TregistersView",
  components: {
    Pendings,
    Registers,
    Down,
    Draft,
    ForEmployee,
    HasEmployee,
    TRegister: () => import("@/components/TRegister"),
  },
  created() {
    // this.getTRegisters(this.$localStorage.get('businessID'))
    // .then(r => {
    //   console.log(r)
    //   this.loading = false
    // })
  },
  data() {
    return {
      loading: true,
      currentComponent: "Draft",
      newUser: null,
      isMassive: false,
      placeholder_tregisters: null,
      placeholder_rightHolders: null,
      file_TRegister: null,
      file_RightHolder: null,
      placeholder_Historic: null,
      file_Historic: null,
      loading_files: false,
      newTregisterDetail: null,
    };
  },
  computed: {
    toogleAddUser() {
      if (window.innerWidth < 600) return true;
      else return false;
    },
    maxBornDate() {
      return new Date(
        new Date().getFullYear() - 18,
        new Date().getMonth(),
        new Date().getDate()
      );
    },
    show() {
      return ["owner", "master", "manager", "normal"].includes(
        this.$store.getters.roleIn
      );
    },
  },

  methods: {
    ...mapActions({
      getTRegisters: "getTRegisters",
      getTRegister: "getTRegister",
    }),
    cargaMasiva() {
      // this.$store.dispatch("massiveUpload", {
      //   id: "",
      //   file: ""
      // });
      let status = "";
      EventBus.$on((val) => {
        status = val;
      });
      this.loading_files = true;
      if (!!this.file_TRegister) {
        this.$store
          .dispatch("massiveUpload", {
            id: window.localStorage.getItem("businessID"),
            file: this.file_TRegister,
          })
          .then((res) => {
            console.log(res);
            this.loading_files = false;
            if (res.status == 200) {
              this.$toasted.success("Archivo cargado", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message",
              });
              this.$toasted.info(
                "Si ha ingresado empleados antiguos, llene su data histórica en la sección de bonos y comisiones del respectivo empleado",
                {
                  theme: "bubble",
                  position: "top-right",
                  duration: 5000,
                  className: "short-message",
                }
              );
            } else {
              this.$toasted.show(
                `Ocurrió un error al subir el archivo: ${res.data.detail}`,
                {
                  theme: "bubble",
                  position: "top-right",
                  duration: 5000,
                  className: "short-message",
                }
              );
            }
            (this.file_TRegister = null), (this.placeholder_tregisters = null);
            this.getTRegisters({
              id: this.$localStorage.get("businessID"),
              state: status,
              page: 1,
            });
            this.isMassive = false;
          })
          .catch((err) => {
            this.$toasted.show(`Ocurrió un error al subir el archivo`, {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message",
            });
            (this.file_TRegister = null), (this.placeholder_tregisters = null);
            this.isMassive = false;
          });
      }
      if (!!this.file_RightHolder) {
        this.$store
          .dispatch("uploadRightHolders", {
            id: window.localStorage.getItem("businessID"),
            file: this.file_RightHolder,
          })
          .then((res) => {
            console.log(res);
            this.loading_files = false;
            if (res.status == 200) {
              this.$toasted.success("Archivo cargado", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message",
              });
            } else {
              this.$toasted.show(
                `Ocurrió un error al subir el archivo: ${res.data.detail}`,
                {
                  theme: "bubble",
                  position: "top-right",
                  duration: 5000,
                  className: "short-message",
                }
              );
            }
            (this.file_RightHolder = null), (this.placeholder_rightHolders = null);
            this.getTRegisters({
              id: this.$localStorage.get("businessID"),
              state: status,
              page: 1,
            });
            this.isMassive = false;
          })
          .catch((err) => {
            this.$toasted.show(`Ocurrió un error al subir el archivo`, {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message",
            });
            (this.file_RightHolder = null), (this.placeholder_rightHolders = null);
            this.isMassive = false;
          });
      }

      if (!!this.file_Historic) {
        this.$store
          .dispatch("uploadHistoric", {
            id: window.localStorage.getItem("businessID"),
            file: this.file_Historic,
          })
          .then((res) => {
            console.log(res);
            this.loading_files = false;
            if (res.status == 200) {
              this.$toasted.success("Archivo cargado", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message",
              });
            } else {
              this.$toasted.show(
                `Ocurrió un error al subir el archivo: ${res.data.detail}`,
                {
                  theme: "bubble",
                  position: "top-right",
                  duration: 5000,
                  className: "short-message",
                }
              );
            }
            (this.file_Historic = null), (this.placeholder_Historic = null);
            this.getTRegisters({
              id: this.$localStorage.get("businessID"),
              state: status,
              page: 1,
            });
            this.isMassive = false;
          })
          .catch((err) => {
            this.$toasted.show(`Ocurrió un error al subir el archivo`, {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message",
            });
            (this.file_Historic = null), (this.placeholder_Historic = null);
            this.isMassive = false;
          });
      }
    },
    getFile($event, type) {
      console.log($event);
      let fr = new FileReader();
      if (!!$event) {
        fr.readAsDataURL($event[0]);

        fr.onload = (fr) => {
          console.log("Loading");
          if (type == "tregister") {
            this.file_TRegister = $event[0];
          }
          if (type == "rightholder") {
            this.file_RightHolder = $event[0];
          }
          if (type == "historic") {
            this.file_Historic = $event[0];
          }
        };
        fr.onabort = (fr) => {
          console.log("abort");
        };
        fr.onerror = (fr) => {
          console.log("error");
        };
      }
    },
    downloadExcel(ref) {
      this.$refs[ref].click();
    },
    toView(value) {
      this.$router
        .push({
          name: value,
        })
        .catch(() => {});
    },
    getTregisterDetails($event) {
      this.getTRegister($event).then((r) => {
        // if(r.data.bornDate == undefined)
        //   r.data.bornDate = this.maxBornDate.toISOString()

        // this.data = r.data
        if (r.status == 200) {
          this.$toasted.success("T-registro creado", {
            theme: "bubble",
            position: "top-right",
            duration: 1000,
            className: "short-message",
          });
          this.newTregisterDetail = Object.assign(
            {
              //NO pueden haber campos en NULL
              //porque no se acepta como payload
              // documentNumber: null,
              bornDate: this.maxBornDate.toISOString(),
              admittedAt: new Date().toISOString(),
              occupation: {
                name: "",
                code: "",
              },

              // firstName: null,
              // firstSurname: null,
              // secondSurname: null,
              // telephone: null,
              // email: null,
              gender: "male",
              // address: null,
              // grossSalary: null,
              personWithDisability: false,
              unionized: false,
            },
            r.data
          );
        } else if (r.status >= 400) {
          this.$toasted.show("hubo un error", {
            theme: "bubble",
            position: "top-right",
            duration: 1000,
            className: "short-message",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS

.tab-selected {
  background-color: #97c2c9 !important;
  font-weight: 700 !important;
  border: 1px solid rgba($b-blue, 0.75) !important;
  border-bottom: 1px solid #fff !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
//FINISH ITCSS

.tregisters {
  background-color: #fff;
  margin-top: 1rem;
  @include mq($lg) {
    margin: 1.5rem 0 0 3rem;
  }

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1rem;
    background-color: #fff;
    position: relative;
  }
  &__tab {
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: $b-blue;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    @include mq($md) {
      cursor: pointer;
    }
  }

  &__add-user {
    position: absolute;
    right: 2rem;
    bottom: 0;
    img {
      height: 2rem;
    }
    button {
      background-color: $b-blue;
      color: #fff;
      border-radius: 3px;
      padding: 0.5rem 1rem;
    }
  }
  &__add-massive {
    position: absolute;
    right: 4.5rem;
    bottom: 0;
    img {
      height: 2rem;
    }
    button {
      background-color: rgba($b-emph, 0.7);
      color: #000;
      border-radius: 3px;
      padding: 0.5rem 1rem;
      transition: all 2ms ease-in;
      &:hover,
      &:active {
        background-color: $b-emph;
        color: #fff;
      }
    }
    @include mq($sm) {
      right: 13rem;
    }
  }

  &__components {
    padding: 0 1rem 1rem 1rem;
    background-color: #fff;
    @include mq($sm) {
      padding: 0 3rem 3rem 3rem;
    }
  }
}
.md-dialog {
  width: 60%;
  min-width: 300px;
  max-width: 600px;
  z-index: 1000 !important;
  .md-field {
    max-width: 80%;
    margin: 8px auto;
  }
}
</style>
